export default{ 
    languages:[
        {languages:"English"},
        {languages:"Hindi"},
        {languages:"German"},
        {languages:"French"},
        {languages:"Portugal"},
        {languages:"Chinese"},
        {languages:"Arabic"},
        
    ],

    time:[
        {times:"15"},
        {times:"30"},
        {times:"60"},
    ],

    price:[
        {prices:"Free"},
        {prices:"Less Than $25"},
        {prices:"$25 - $50"},
        {prices:"$50 - $100"},
        {prices:"More Than $100"},
    ],

  


}